import React from "react";

export default function CareerHead() {
  return (
    <>
      <div className="container text-center">
        <div className="row">
          <div className="col-md-12 mt-5 mb-3">
            <h2>Career Opportunities</h2>
          </div>
        </div>
      </div>
    </>
  );
}
